export default [
  {
    path: '/account',
    component: () => import('@/components/layouts/account-layout.vue'),
    meta: { title: 'Account', authenticated: true, activeUser: true },
    children: [
      {
        name: 'account#index',
        path: '',
        meta: { title: 'Summary' },
        component: () => import('@/views/account/index-view.vue'),
      },
      {
        path: 'update',
        meta: { title: 'Manage Account' },
        children: [
          {
            name: 'account#update',
            path: '',
            component: () => import('@/views/account/update/index-view.vue'),
          },
          {
            name: 'account#details',
            path: 'details',
            meta: { title: 'Details' },
            component: () => import('@/views/account/update/details-view.vue'),
          },
          {
            name: 'account#account-features',
            path: 'account-features',
            meta: { title: 'Features' },
            component: () => import('@/views/account/update/features-view.vue'),
          },
          {
            name: 'account#subscription',
            path: 'subscription',
            meta: { title: 'Subscription' },
            component: () => import('@/views/account/update/subscription-view.vue'),
          },
          {
            name: 'account#close',
            path: 'close',
            meta: { title: 'Close Account' },
            component: () => import('@/views/account/update/close-view.vue'),
          },
        ],
      },
      {
        name: 'account#activity',
        path: 'activity',
        meta: { title: 'Activity' },
        component: () => import('@/views/account/activity-view.vue'),
      },
      {
        name: 'account#gainloss',
        path: 'gainloss',
        meta: { title: 'Gain/Loss' },
        component: () => import('@/views/account/gainloss-view.vue'),
      },
      {
        name: 'account#orders',
        path: 'orders',
        meta: { title: 'Orders' },
        component: () => import('@/views/account/orders-view.vue'),
      },
      {
        name: 'account#positions',
        path: 'positions',
        meta: { title: 'Positions' },
        component: () => import('@/views/account/positions-view.vue'),
      },
      {
        name: 'account#statements',
        path: 'statements',
        meta: { title: 'Statements' },
        component: () => import('@/views/account/statements-view.vue'),
      },
      {
        name: 'account#export',
        path: 'export',
        meta: { title: 'Export' },
        component: () => import('@/views/account/export-view.vue'),
      },
    ],
  },

  // Force the onboarding layout for the following routes
  {
    path: '/account/new',
    component: () => import('@/components/layouts/onboarding-layout.vue'),
    children: [
      {
        name: 'account#new',
        path: '',
        meta: { title: 'New', authenticated: true, activeUser: false, enabled: true },
        component: () => import('@/views/account/new-view.vue'),
      },
    ],
  },
  {
    path: '/account/create',
    component: () => import('@/components/layouts/onboarding-layout.vue'),
    children: [
      {
        name: 'account#create',
        path: '',
        meta: { title: 'Application', authenticated: true, activeUser: false, enabled: true },
        component: () => import('@/views/account/create-view.vue'),
      },
    ],
  },
];
